export default __webpack_public_path__ + "static/media/Dispatch.418417c4.svg";